module.exports = __webpack_public_path__ + "static/media/swaparoundlogo_white.442b4604.png";